(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('TableauNombreJourneePerduCtrl', TableauNombreJourneePerduCtrl);

    TableauNombreJourneePerduCtrl.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService'];

    function TableauNombreJourneePerduCtrl ($scope, $state, ParseLinks, AlertService) {


    }
})();
